import React, { useState } from 'react';
import ListaVolumes from './ListaVolumes/ListaVolumes';
import DetalheVolume from './DetalheVolume/DetalheVolume';
import './Paletizacao.css';
import { MODALIDADES } from './modalidades';

function Paletizacao() {
  const [modalidade, setModalidade] = useState('embalagem');
  const [tela, setTela]               = useState('lista');
  const [job, setJob]                 = useState(null);
  const [volumes, setVolumes]         = useState([]);
  const [volumeAtivo, setVolumeAtivo] = useState(null);
  const [planoAtivo, setPlanoAtivo]   = useState(null);
  // POC temporário (jul/2026) — código 81 manual do lote; substituir por vínculo ao produto cadastrado no futuro
  const [codigo81Lote, setCodigo81Lote] = useState('');

  // ── Handlers de job/volumes (Tela 1) ───────────────────────────────────────

  const handleJobCarregado = (data) => {
    if (!data) return;
    setJob({
      job_id:        data.job_id,
      total_volumes: data.total_volumes,
      erros_parse:   data.erros_parse ?? [],
    });
    setVolumes(data.volumes ?? []);
  };

  const handleNovoUpload = () => {
    setJob(null);
    setVolumes([]);
  };

  const handleAtualizarVolumeStatus = (volumeId, novoStatus) => {
    setVolumes(prev =>
      prev.map(v => v.id === volumeId ? { ...v, status: novoStatus } : v)
    );
  };

  // ── Navegação entre telas ──────────────────────────────────────────────────

  const handleIrParaDetalhe = (volume, plano) => {
    setVolumeAtivo(volume);
    setPlanoAtivo(plano);
    setTela('detalhe');
  };

  const handleVoltar = () => {
    setTela('lista');
  };

  const handleVolumeAtualizadoDetalhe = (novoStatus) => {
    if (volumeAtivo) {
      handleAtualizarVolumeStatus(volumeAtivo.id, novoStatus);
    }
  };

  // ── Render ─────────────────────────────────────────────────────────────────

  if (tela === 'detalhe' && volumeAtivo) {
    return (
      <div className="pal-root">
        <DetalheVolume
          volume={volumeAtivo}
          planoInicial={planoAtivo}
          onVoltar={handleVoltar}
          onVolumeAtualizado={handleVolumeAtualizadoDetalhe}
          codigo81={codigo81Lote}
          modalidade={modalidade}
        />
      </div>
    );
  }

  return (
    <div className="pal-root">
      <label className="pal-modalidade-label">
        Modalidade
        <select value={modalidade} onChange={e => {
          setModalidade(e.target.value);
          setJob(null);
          setVolumes([]);
        }}>
          {Object.entries(MODALIDADES).map(([id, config]) => (
            <option key={id} value={id}>{config.label}</option>
          ))}
        </select>
      </label>
      {modalidade === 'lojas_cem' && (
        <p className="pal-modalidade-aviso">Peso máximo: 1.000 kg. O cálculo prioriza o maior peso válido.</p>
      )}
      <ListaVolumes
        modalidade={modalidade}
        job={job}
        volumes={volumes}
        onJobCarregado={handleJobCarregado}
        onNovoUpload={handleNovoUpload}
        onAtualizarVolumeStatus={handleAtualizarVolumeStatus}
        onIrParaDetalhe={handleIrParaDetalhe}
        codigo81={codigo81Lote}
        onCodigo81Change={setCodigo81Lote}
      />
    </div>
  );
}

export default Paletizacao;
